module.exports = __webpack_public_path__ + "img/bg1.daaecc58.png";